import React from 'react';
import { Users, Pill, FileText, Heart, Link2, Stethoscope } from 'lucide-react';

const ServicesSection = () => {
  const services = [
    {
      icon: <Users className="w-8 h-8" />,
      title: 'Therapy Services',
      description: 'Evidence-based therapeutic care for adults and minors, delivered individually, in groups, with families or couples, and through trauma-informed modalities.',
      features: ['Individual Therapy', 'Group Therapy', 'Family Counselling', 'Couples Therapy', 'Trauma-Focused Care', 'Adults & Minors']
    },
    {
      icon: <Pill className="w-8 h-8" />,
      title: 'Medication Management',
      description: 'Our licensed clinicians carefully manage medications based on assessed needs using evidence-based practices.',
      features: ['Our Experts Medication Management Provider', 'Regular Monitoring', 'Personalized Plans', 'Safety First']
    },
    {
      icon: <FileText className="w-8 h-8" />,
      title: 'Individualized Treatment Plans',
      description: 'Comprehensive assessments and personalized treatment strategies tailored to your unique needs and goals.',
      features: ['Custom Plans', 'Goal-Oriented', 'Progress Tracking', 'Flexible Approach']
    },
    {
      icon: <Heart className="w-8 h-8" />,
      title: 'Psychiatric Rehabilitation Program (PRP)',
      description: 'Evidence-based practices focused on empowering and restoring wellbeing and self-worth.',
      features: ['Skill Building', 'Community Support', 'Recovery Focus', 'Long-term Success']
    },
    {
      icon: <Link2 className="w-8 h-8" />,
      title: 'Community Resources',
      description: 'Access to vital community resources and support networks to maximize individual and collective potential.',
      features: ['Resource Navigation', 'Support Groups', 'Community Links', 'Ongoing Support']
    },
    {
      icon: <Stethoscope className="w-8 h-8" />,
      title: 'Comprehensive Assessment',
      description: 'Thorough evaluations to understand root causes and develop effective treatment strategies.',
      features: ['Initial Evaluation', 'Diagnostic Clarity', 'Treatment Planning', 'Ongoing Assessment']
    }
  ];

  return (
    <section id="services" className="py-20 bg-white" data-testid="services-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Our Services
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Outpatient therapy, psychiatric rehabilitation, medication management, and wraparound support for children, adults, and families.
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service) => (
            <div
              key={service.title}
              className="bg-white border border-gray-200 rounded-xl p-6 hover:shadow-xl transition-shadow duration-300"
            >
              <div className="text-blue-600 mb-4">{service.icon}</div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">{service.title}</h3>
              <p className="text-gray-600 mb-4">{service.description}</p>
              <ul className="space-y-2">
                {service.features.map((feature) => (
                  <li key={feature} className="flex items-center text-sm text-gray-700">
                    <span className="w-1.5 h-1.5 bg-blue-600 rounded-full mr-2"></span>
                    {feature}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;